import { useMutation } from '@tanstack/react-query'

import type { ApiError } from '@/lib/api/errors'
import { updateCampaign } from '@/lib/venue/campaignApi'
import type { VenueCampaignDetailView, VenueCampaignUpdateInput } from '@/lib/venue/campaignTypes'

/**
 * 내용 수정(#714 §4-1, #732에서 처음 소비) — "이어서 작성" 흐름의 저장 단계(DRAFT 전용, 호출부가 제한).
 * 🚨 여기서 목록·요약·상세 쿼리를 무효화하지 않는다 — 내용 수정만으로는 목록에 노출할 만한 상태
 * 변화가 없다(무효화는 발송/예약 확정 시에만, #729 §자율 결정 3과 같은 원칙).
 */
export function useUpdateCampaign(venueId: string) {
  return useMutation<VenueCampaignDetailView, ApiError, { campaignId: number; input: VenueCampaignUpdateInput }>({
    mutationFn: ({ campaignId, input }) => updateCampaign(venueId, campaignId, input),
  })
}
